import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { throttle } from 'lodash';

// Redux
import { Provider } from 'react-redux';
import appReducers from 'reducers';
import { markerboardRef, checkForSignIn } from './firebase';
import { createStore } from 'redux';

// Main component
import Board from './Board';
import LoadingScreen from 'components/LoadingScreen';
import { urlTitle } from 'utils/formatters';
import DropColumnButton from 'components/DropColumnButton';
const subtitle = urlTitle(window.location.pathname);

let writeToFirebase = true;
class App extends Component {
  state = {
    loading: true,
  };

  setStoreTest = () => {
    const store = createStore(appReducers);
    this.store = store;
    this.setState({ loading: false });
    return;
  };

  setStore = result => {
    const path = window.location.pathname;

    markerboardRef(path).on('value', snapshot => {
      const data = snapshot.val();
      let initialState;
      if (data) {
        initialState = {
          ...data,
          user: result.user,
          projects: (data.projects || []).map(p => ({
            ...p,
            weeks: (p.weeks || []).map(w => ({
              ...w,
              developers: (w.developers || []).map(d => ({
                ...d,
              })),
            })),
          })),
        };
      }

      if (this.state.loading) {
        const store = createStore(appReducers, initialState);
        store.subscribe(
          throttle(() => {
            if (writeToFirebase) {
              const { user, ...newState } = store.getState();
              markerboardRef(path).set(newState);
            }
          }, 1000),
        );
        this.store = store;
        this.setState({ loading: false });
      } else {
        writeToFirebase = false;
        this.store.dispatch({ type: 'RELOAD_DATA', data: initialState });
        writeToFirebase = true;
      }
    });
  };

  componentDidMount() {
    if (process.env.NODE_ENV === 'test') {
      this.setStoreTest();
    } else {
      checkForSignIn({ ifAuthorized: this.setStore });
    }
  }

  render() {
    if (this.state.loading) {
      return <LoadingScreen />;
    }

    return (
      <Provider store={this.store}>
        <div className="App">
          <header
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
            className="App-header"
          >
            <div style={{ width: 100 }} />
            <div>
              <img src={logo} className="App-logo" alt="logo" />
              {subtitle && <div style={styles.title}>{subtitle}</div>}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                style={{ height: 50, width: 50, borderRadius: 25 }}
                src={this.store.getState().user.photoURL}
                alt="user"
              />
              {this.store.getState().user.displayName}
              <DropColumnButton />
            </div>
          </header>
          <div>
            <Board />
          </div>
        </div>
      </Provider>
    );
  }
}

const styles = {
  title: {
    textAlign: 'center',
    fontSize: 28,
    color: '#bfb8b8',
  },
};
export default App;



// WEBPACK FOOTER //
// ./src/App.js